import { useState, useEffect } from "react";
import { loadStorageLocationList, loadWarehouseList, loadWarehouseTypeList } from "../../services/warehouseService";

const useWarehouseStorageLocationList = (Mode) => {
    const [warehouseStorageLocationList, setWarehouseStorageLocationList] = useState([]);
    const [isWarehouseLocationDataLoaded, setIsWarehouseLocationDataLoaded] = useState(false);
    const [selectedWarehouseStorageLocation, setSelectedWarehouseStorageLocation] = useState(null);
    const [selectedWarehouseStorageLocationID, setSelectedWarehouseStorageLocationID] = useState(null);

    const fetchWarehouseStorageLocationList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1 };

        try {
            const data = await loadStorageLocationList(para);
            if (data && data.length > 0) {
                setWarehouseStorageLocationList(data);

                const initialWarehouse = data.find((dept) => dept.warehouse_location_id === selectedID);

                if (initialWarehouse) { // ✅ Corrected check
                    setSelectedWarehouseStorageLocation(initialWarehouse);
                    setSelectedWarehouseStorageLocationID(initialWarehouse.warehouse_location_id);
                    setIsWarehouseLocationDataLoaded(true);
                }


            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isWarehouseLocationDataLoaded) {
            fetchWarehouseStorageLocationList();
        }
    }, [isWarehouseLocationDataLoaded]);

    // Function to load department based on selected ID
    const loadWarehouseStorageLocationByID = async (selectedID) => {
        await fetchWarehouseStorageLocationList(selectedID);
    };


    return {
        warehouseStorageLocationList,
        selectedWarehouseStorageLocation,
        selectedWarehouseStorageLocationID,
        setSelectedWarehouseStorageLocation,
        setSelectedWarehouseStorageLocationID,
        loadWarehouseStorageLocationByID,
    };
};

export default useWarehouseStorageLocationList;
